/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import ClickableDiv from 'components/Common/ClickableDiv';
import HideableContainer from 'components/Common/HideableContainer';
import { useHistory } from 'react-router-dom';
import Styles from './index.module.css';

export default function LoginNavButtons({
  step, onChangeStep, children, ...props
}) {
  const history = useHistory();

  return (
    <div className={Styles.mainContainer} {...props}>
      <HideableContainer className={Styles.content}>
        <ClickableDiv
          onClick={() => { history.push('/Register'); }}
          className={Styles.link}
        >
          {/* <span>立即</span> */}
          <span>註冊</span>
        </ClickableDiv>
        <span className={Styles.divider}>/</span>
        <ClickableDiv
          onClick={() => { history.push('/Register'); }}
          className={Styles.link}
        >
          登入
        </ClickableDiv>
        {children}
      </HideableContainer>
    </div>
  );
}

LoginNavButtons.propTypes = {
  step: PropTypes.string,
  children: PropTypes.node,
  onChangeStep: () => {},
};

LoginNavButtons.defaultProps = {
  step: '',
  children: null,
  onChangeStep: () => {},
};
